var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var DualRowPackageWithJOrLLeadPadGeneratorInteractionModel = require("../dualRowPackageWithJOrLLeadPadGeneratorInteractionModel.js");
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var OscillatorJLeadPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    DualRowPackageWithJOrLLeadPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(OscillatorJLeadPadGeneratorInteractionModel, DualRowPackageWithJOrLLeadPadGeneratorInteractionModel);
OscillatorJLeadPadGeneratorInteractionModel.$class = 'OscillatorJLeadPadGeneratorInteractionModel';

module.exports = OscillatorJLeadPadGeneratorInteractionModel;

OscillatorJLeadPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintOscJ));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadSpan1InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalCenterCenterDistance());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};